import React from 'react';
import './App.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Listing from './Pages/Listing/Listing';
import Event from './Pages/Event/Event';
import Main from './Pages/Template/Main';
import Template from './Pages/Template/Template';
import { useState } from 'react';
import SiteSetting from './Context/SiteSetting';
import ThankYou from './Pages/ThankYou/ThankYou';
import TermsConditions from './Pages/TermsConditions/TermsConditions';


function App() {
  const [ setting, setSetting ] = useState(null);

  const onUpdateSetting = (data) => {
    setSetting(data);
  };

  return (
    <SiteSetting.Provider value={{ setting, onUpdateSetting }}>
      <BrowserRouter>
        <Routes>
          <Route element={<Main />}>

            <Route element={<Template />}>
              <Route path="/:account" element={<Listing />} />
              <Route path="/:account/event/:eventID" element={<Event />} />
              <Route path="/:account/thank-you" element={<ThankYou />} />
              <Route path="/:account/terms-and-conditions" element={<TermsConditions />} />
            </Route>

            <Route path="/:account/event/:eventID/embed" element={<Event type="embed" />} />
            <Route path="/:account/embed" element={<Listing type="embed" />} />

          </Route>
        </Routes>
      </BrowserRouter>
    </SiteSetting.Provider>
  )
}

export default App;
